const STRING_KEYS = [
  'email',
  'firstname',
  'lastname',
  'first_name',
  'last_name',
  'name',
  'display_name',
  'full_name',
];

const NESTED_KEYS = ['account', 'boatpark_account', 'user', 'profile'];

function pushTrimmedLower(sink, value) {
  if (value == null || value === '') return;
  const s = String(value).trim();
  if (s) sink.push(s.toLowerCase());
}

function collectFromObject(obj, sink) {
  if (!obj || typeof obj !== 'object') return;
  for (const key of STRING_KEYS) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      pushTrimmedLower(sink, obj[key]);
    }
  }
}

function collectAllSearchHaystacks(account) {
  const sink = [];
  collectFromObject(account, sink);
  for (const nestKey of NESTED_KEYS) {
    collectFromObject(account?.[nestKey], sink);
  }
  return sink;
}

/**
 * @param {Record<string, unknown>} account item from AuthorizedAccounts / get_my_account_authoritations
 * @param {string} rawQuery
 */
export function authorizedAccountMatchesSearch(account, rawQuery) {
  const q = String(rawQuery || '').trim().toLowerCase();
  if (!q) return true;
  return collectAllSearchHaystacks(account).some((hay) => hay.includes(q));
}
